/* eslint-disable no-undef */
$(function () {
  // set change-event for paikkakunta select
  $('#paikkakunta-select').on('change', function () {
    const newPlace = $(this).find('option:selected').val()
    showPlace(newPlace)
  })

  // show place
  function showPlace (placeId) {
    if(placeId !== '') {
      // other places
      $('.place-container:not("#' + placeId + '")').css('display', 'none')
      // show new option
      $('#' + placeId).css('display', 'block')
    } else {
      // show all places
      $('.place-container').css('display', 'block')
    }
    
  }
})

/* $('#your_file').bind('change', function () {
  var filename = $(this).val().split('\\').pop()
  $('#file-selected').html(filename)
}) */
